/**
 * Seconds as a playback position — "5:05", or "1:02:33" once past the hour.
 *
 * Distinct from `formatDuration`, which reads as a length ("1h 23m 45s"). A
 * citation into a recording is a POSITION: it has to match what the player's
 * own scrubber shows, so an officer can see they landed where the citation
 * said.
 */
export const formatTimecode = (seconds: number): string => {
  const safe = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
  const h = Math.floor(safe / 3600);
  const m = Math.floor((safe % 3600) / 60);
  const s = safe % 60;
  const ss = s.toString().padStart(2, "0");
  return h > 0 ? `${h}:${m.toString().padStart(2, "0")}:${ss}` : `${m}:${ss}`;
};
